<script>
import { BTableSimple } from "bootstrap-vue";

export default {
  extends: BTableSimple
};
</script>